import React from 'react';
import { Link } from 'react-router-dom';
import { inline } from './RichText';

export const LegalLayout = ({ eyebrow, title, intro, updated, sections, testId, children }) => (
  <div className="w-full px-margin-mobile lg:px-margin py-space-2xl" data-testid={testId}>
    <div className="max-w-3xl mx-auto">
      <div className="flex items-center flex-wrap gap-space-xs text-on-surface-variant font-label-md text-label-md uppercase tracking-wider mb-space-lg">
        <Link to="/" className="hover:text-surface-tint transition-colors">Home</Link>
        <span className="text-surface-container-highest">/</span>
        <span className="text-outline font-extrabold">{title}</span>
      </div>

      <span className="font-label-sm text-label-sm uppercase tracking-widest text-surface-tint font-bold block mb-space-xs">{eyebrow}</span>
      <h1 className="font-display-hero text-[32px] leading-[38px] md:text-headline-lg text-outline uppercase tracking-tight">{title}</h1>
      <p className="font-body-lg text-body-lg text-on-surface-variant mt-space-md leading-relaxed">{inline(intro)}</p>
      {updated ? (
        <p className="font-label-sm text-label-sm uppercase tracking-wider text-on-surface-variant mt-space-md">Last updated: {updated}</p>
      ) : null}

      <div className="mt-space-2xl flex flex-col gap-space-xl">
        {sections.map((s) => (
          <section key={s.heading}>
            <h2 className="font-headline-sm text-headline-sm text-outline uppercase tracking-tight mb-space-sm">{s.heading}</h2>
            {(s.paragraphs || []).map((p) => (
              <p key={p} className="font-body-md text-body-md text-on-surface-variant leading-relaxed mb-space-sm">{inline(p)}</p>
            ))}
            {s.ordered ? (
              <ol className="list-decimal pl-5 flex flex-col gap-space-xs mb-space-sm">
                {s.ordered.map((b) => (
                  <li key={b} className="font-body-md text-body-md text-on-surface-variant leading-relaxed">{inline(b)}</li>
                ))}
              </ol>
            ) : null}
            {s.bullets ? (
              <ul className="list-disc pl-5 flex flex-col gap-space-xs">
                {s.bullets.map((b) => (
                  <li key={b} className="font-body-md text-body-md text-on-surface-variant leading-relaxed">{inline(b)}</li>
                ))}
              </ul>
            ) : null}
            {s.after ? (
              <p className="font-body-md text-body-md text-on-surface-variant leading-relaxed mt-space-sm">{inline(s.after)}</p>
            ) : null}
            {s.contactEmail ? (
              <p className="font-body-md text-body-md text-on-surface-variant leading-relaxed" data-testid="legal-contact">
                Questions?{' '}
                <a
                  href={`mailto:${s.contactEmail}`}
                  data-testid="legal-contact-email"
                  className="text-surface-tint font-semibold hover:text-primary transition-colors break-all"
                >
                  {s.contactEmail}
                </a>
              </p>
            ) : null}
          </section>
        ))}
      </div>

      {children}
    </div>
  </div>
);

export default LegalLayout;
